/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Input, Button, Space, Divider } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import useClickListener from '../../helper/outsideClickListener';
import VariationActions from '../../redux/middleware/variation';
import Utils from '../../redux/utils';
import Delete from '../../assets/images/Delete.svg';
import ArrowDownBlack from '../../assets/svg/arrowDownblack.svg';
import CookingMethodSteps from './CookingMethodStep';
import './CookingMethodDropdown.scss';

type Props = {
  CookingVariation: any;
  searchedValue: any;
  showRecipeView: any;
  recipes: any;
  handleChangeSearchedValue: any;
  handleSelectOption: any;
  handleDeleteRecipe: any;
  handleAddItem: any;
  handleAddRecipeStep: any;
  handleDeleteRecipeStep: any;
  handleStepValue: any;
  onSubmitCookingMethod: any;
  errorStatus?: boolean;
  errorList?: any;
  setActiveStepIndex?: any;
  activeStepIndex?: any;
  steps?: any;
  cookingMenu?: any;
};

const CookingMethodComponent = (props: Props) => {
  let {
    CookingVariation,
    searchedValue,
    showRecipeView,
    recipes,
    handleChangeSearchedValue,
    handleSelectOption,
    handleDeleteRecipe,
    handleAddItem,
    handleAddRecipeStep,
    handleDeleteRecipeStep,
    handleStepValue,
    onSubmitCookingMethod,
    errorStatus,
    errorList,
    steps,
    cookingMenu,
  } = props;

  const company = Utils.getCurrentCompany();
  const user = Utils.getCurrentUser();
  const { ref, isComponentVisible, setIsComponentVisible } =
    useClickListener(true);
  const [addCooking, setAddCooking] = useState(true);
  const [cookinginput, setCookinginput] = useState(false);
  const [variation, setVariation] = React.useState('');

  const handleClick = () => {
    setIsComponentVisible(!isComponentVisible);
  };

  const handleSelectOptionValue = (ingredient: any) => {
    handleSelectOption(ingredient);
    setIsComponentVisible(false);
    setAddCooking(!addCooking);
    setCookinginput(false);
  };

  const handleAdd = () => {
    // setIsComponentVisible(true);
    setAddCooking(true);
    handleAddItem();
    setCookinginput(!cookinginput);
  };

  return (
    <div className="recipeStepperContainer">
      {/* <div className="wizardSubContainer checkBox">
        <Checkbox onChange={onChangeMenu} value={menu}>
          Multiple Cooking Methods
        </Checkbox>
      </div> */}
      <div className="wizardSubContainer">
        <div className="headingContainer">
          <div className="wizardLabel">
            {' '}
            Cooking Methods <span className="sterik">*</span>{' '}
          </div>
          {/* {menu ? ( */}
          <div className="wizardLabel" onClick={() => handleAdd()}>
            <span className="plus">+</span> Add Item
          </div>
          {/* ) : null}  */}
        </div>

        <div className="Recipe-form-group" ref={ref}>
          {addCooking && (
            <Input
              type="text"
              placeholder="Select Cooking Method"
              onClick={handleClick}
              onChange={(e) => handleChangeSearchedValue(e)}
              value={cookinginput ? '' : searchedValue}
              className={
                errorList['name']?.length > 0 ? 'dropdownColorRed' : ''
              }
            />
          )}

          {isComponentVisible ? (
            <ul className="dropdown-list">
              <li>
                <ul className="subMenu">
                  <li>
                    <h4 className="placeholder">Select an option</h4>
                  </li>
                  {CookingVariation?.map((method: any, index: number) => {
                    return (
                      <li
                        key={index}
                        onClick={() => handleSelectOptionValue(method)}
                      >
                        <p>{method?.name} </p>
                      </li>
                    );
                  })}
                  <li>
                    <Divider style={{ margin: '8px 0' }} />
                    <Space style={{ padding: '0 8px 4px' }}>
                      <Input
                        placeholder="Please enter method"
                        value={variation}
                        onChange={(e) => setVariation(e.target.value)}
                        style={{ width: 180, marginRight: '5px' }}
                      />
                      <Button
                        type="text"
                        icon={<PlusOutlined />}
                        onClick={() => {
                          variation !== '' && onSubmitCookingMethod(variation);
                          setVariation('');
                        }}
                      >
                        Add New Method
                      </Button>
                    </Space>
                    {errorStatus && (
                      <div className="subRecipeErrorMessages error-cat">
                        {errorList['name']}
                      </div>
                    )}
                  </li>
                </ul>
              </li>
            </ul>
          ) : null}
          {showRecipeView
            ? recipes.map((recipe: any, index: number) => {
                return (
                  <div key={index} className="drop-down-wrapper">
                    <div className="drop-down">
                      <div className="drop-down-header">
                        <p>{recipe?.name}</p>
                        <button>
                          {/* <img src={ArrowDownBlack} alt={''} /> */}
                        </button>
                      </div>
                      <div className="drop-down-content">
                        <h4>
                          Steps <span className="sterik">*</span>
                        </h4>
                        <CookingMethodSteps
                          recipe={recipe}
                          index={index}
                          handleAddRecipeStep={handleAddRecipeStep}
                          handleStepValue={handleStepValue}
                          handleDeleteRecipeStep={handleDeleteRecipeStep}
                          steps={steps}
                          cookingMenu={cookingMenu}
                        />

                        <div
                          className="addItem"
                          onClick={() => handleAddRecipeStep(recipe, index)}
                        >
                          <span className="plus">+</span> Add Item
                        </div>
                      </div>
                    </div>
                    <button
                      className="wrapper-btn"
                      onClick={() => handleDeleteRecipe(recipe)}
                    >
                      <img src={Delete} width={15} alt="" />
                    </button>
                  </div>
                );
              })
            : null}
        </div>
      </div>
    </div>
  );
};

export default CookingMethodComponent;
